module.exports = __webpack_public_path__ + "assets/img/36_656.4d8ade96.jpg";